import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { Invoice } from '../../models/invoice-details.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-invoice-details-table',
    imports: [CommonModule, MatCardModule, TranslatePipe],
    templateUrl: './invoice-details-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './invoice-details-table.component.scss'
})
export class InvoiceDetailsTableComponent {
    @Input() invoice?: Invoice;

    expandedRows = new Set<string>();

    toggleRow(key: string): void {
        if (this.expandedRows.has(key)) {
            this.expandedRows.delete(key);
        } else {
            this.expandedRows.add(key);
        }
    }

    isExpanded(key: string): boolean {
        return this.expandedRows.has(key);
    }

    get dueDate(): Date | undefined {
        if (!this.invoice) return undefined;
        const invoiceDate = new Date(this.invoice.date);
        invoiceDate.setDate(invoiceDate.getDate() + 5);
        return invoiceDate;
    }

    get groupedItems() {
        if (!this.invoice) return [];

        const groups = [];

        const besparelserChildren = this.invoice.items.filter(
            i =>
                i.description === 'Opladninger' ||
                i.description === 'Afladninger'
        );

        const besparelserTotal = besparelserChildren.reduce(
            (sum, item) => sum + item.totalPrice,
            0
        );

        groups.push({
            key: 'besparelser',
            description: 'Besparelser',
            quantity: 1,
            unit: 'kr',
            unitPrice: besparelserTotal,
            price: besparelserTotal,
            children: besparelserChildren
        });

        const otherItems = this.invoice.items.filter(
            i =>
                i.description !== 'Opladninger' &&
                i.description !== 'Afladninger'
        );

        otherItems.forEach(item => {
            groups.push({
                key: item.description,
                description: item.description,
                quantity: item.quantity,
                unit: item.unit,
                unitPrice: item.unitPrice,
                price: item.totalPrice,
                children: []
            });
        });

        return groups;
    }
}
